import React, { useEffect, useState } from 'react';
import './OpinionsPage.scss';
import { Autocomplete, MenuItem, TextField, Select, Skeleton } from '@mui/material';
import { OpinionContent } from './OpinionContent';
import { getOpinions } from '../../data/api';

export const OpinionsPage = ({ toggleAddOpinion }) => {
  const [opinions, setOpinions] = useState([]);
  const [selectedCareer, setSelectedCareer] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [courses, setCourses] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);  // Estado para manejar la carga

  const specialtiesMap = {
    "7": "Ingeniería Eléctrica",
    "9": "Ingeniería Electrónica",
    "17": "Ingeniería Mecánica",
    "24": "Ingeniería Industrial",
    "27": "Ingeniería Química",
    "31": "Ingeniería Civil",
    "H": "Homogéneas"
  };

  useEffect(() => {
    const loadData = async () => {
      const content = require('../../data/horarios.json');
      setData(content);
    };
    loadData();
  }, []);

  useEffect(() => {
    const fetchOpinions = async () => {
      try {
        setLoading(true);  // Inicia la carga
        const response = await getOpinions();
        setOpinions(response.opinions);
      } catch (error) {
        console.error("Error fetching opinions:", error);
      } finally {
        setLoading(false);  // Finaliza la carga
      }
    };

    fetchOpinions();
  }, []);

  const handleCareerChange = (event, value) => {
    setSelectedCareer(value);

    const filteredSubjects = data.filter(item => value.includes(specialtiesMap[item.esp]));
    setSubjects([...new Set(filteredSubjects.map(item => item.subject))]);
    setSelectedSubject([]);
    setSelectedCourse([]);
  };

  const handleSubjectChange = (event, value) => {
    setSelectedSubject(value);

    const filteredCourses = data.filter(item => value.includes(item.subject));
    setCourses([...new Set(filteredCourses.map(item => item.course))]);
    setSelectedCourse([]);
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
  };

  // Filtrar opiniones según los filtros seleccionados
  const filteredOpinions = opinions.filter(opinion => {
    const matchesCareer = selectedCareer.length === 0 || selectedCareer.includes(specialtiesMap[opinion.career]);
    const matchesSubject = selectedSubject.length === 0 || selectedSubject.includes(opinion.subject);
    const matchesCourse = selectedCourse.length === 0 || selectedCourse.includes(opinion.course);
    
    return matchesCareer && matchesSubject && matchesCourse;
  });

  return (
    <div className="opinions_container">
      <div className="opinions_btns">
        <button className='btn-add-opinion' onClick={toggleAddOpinion}>+ Agregar nueva opinión</button>
        
        <Autocomplete
          multiple
          disablePortal
          id="carrera-selector"
          options={[...new Set(data.map(item => specialtiesMap[item.esp]))]}
          sx={{ minWidth: 200 }}
          onChange={handleCareerChange}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Elegir carreras"
              InputProps={{ ...params.InputProps, style: { height: '50px' } }}
            />
          )}
        />

        <Autocomplete
          multiple
          disablePortal
          id="materia-selector"
          options={subjects}
          sx={{ minWidth: 200}}
          onChange={handleSubjectChange}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Elegir materias"
              InputProps={{ ...params.InputProps, style: { height: '50px' } }}
            />
          )}
          disabled={selectedCareer.length === 0}
        />

        <Select
          id="comision-selector"
          value={selectedCourse}
          onChange={handleCourseChange}
          displayEmpty
          sx={{ minWidth: 200, height: '50px' }}
          disabled={selectedSubject.length === 0}
        >
          <MenuItem value="" disabled>Selecciona una comisión</MenuItem>
          {courses.map(course => (
            <MenuItem key={course} value={course}>{course}</MenuItem>
          ))}
        </Select>
      </div>

      <div className="opinions_list">
        {loading ? (
          // Mostrar skeletons mientras se cargan las opiniones
          <>
            <Skeleton variant="rectangular" width={350} height={400} style={{margin: 10, borderRadius: 10}}/>
            <Skeleton variant="rectangular" width={350} height={400} style={{margin: 10, borderRadius: 10}} />
            <Skeleton variant="rectangular" width={350} height={400} style={{margin: 10, borderRadius: 10}} />
          </>
        ) : filteredOpinions && filteredOpinions.length > 0 ? (
          filteredOpinions.map((opinion) => (
            <OpinionContent 
              key={opinion._id} 
              opinion={opinion} 
            />
          ))
        ) : (
          <p>No hay opiniones disponibles que coincidan con los filtros.</p>
        )}
      </div>
    </div>
  );
};
